export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-play-4107b57959933389e01066c4aa902f81.svg";